import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Log} from "@angular/core/testing/src/logger";
import {log} from "util";

@Component({
    selector: "app-chip",
    templateUrl: "./chip.component.html",
    styleUrls: ["./chip.component.css"]
})
export class ChipComponent {

    @Input() name = "Te Gjitha";
    @Output() chipRemove$ = new EventEmitter<string>();

    onCloseClick(event: MouseEvent): void {
        const el = event.target as HTMLElement;
        const name =
            el.localName === "path" ?
                this.getNameProperty((el.parentNode as HTMLElement)) :
                this.getNameProperty(el as HTMLElement);

        this.chipRemove$.emit(name);
    }

    private getNameProperty = (element: HTMLElement) => element.dataset.name;

}
